//@ts-nocheck
// 通用对话 & 流式moe对话
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import cls from "classnames";
import { observer } from "mobx-react";
import FeedBackBar from "@/components/Feedback/FeedBackBar";
import { useEffect, useState, useRef, useCallback, Fragment } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useDebounceFn } from "ahooks";
import { Tooltip, Popover } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { EChatModel } from "logic/src/objects/chat/types";
import { UploadedFile } from "logic/src/objects/file/types";
import { WaterMark } from "antd-mobile";
import Chat from "logic/src/objects/chat/model";
import { ReactComponent as DeepThink } from "logic/src/components/icons/deepthink.svg";
import { ReactComponent as VideoCaptureIcon } from "logic/src/components/icons/videoCapture.svg";
import { ReactComponent as AmazingCaptureIcon } from "logic/src/components/icons/amazingCapture.svg";
import { ReactComponent as DetailDescriptionIcon } from "logic/src/components/icons/detailDescription.svg";
import { ReactComponent as AudioAnalysisIcon } from "logic/src/components/icons/audioAnalysis.svg";
import RichmodalVM from "logic/src/businesses/richmodal/vm";
import useMessage from "logic/src/utils/useMessage";
import useScroll from "logic/src/utils/useScroll";
import { ReactComponent as Plus } from "logic/src/components/icons/plus.svg";
import { ReactComponent as Logo } from "logic/src/components/icons/logo.svg";
import { ReactComponent as Fold } from "logic/src/components/icons/fold.svg";
import { ReactComponent as UnFold } from "logic/src/components/icons/unFold.svg";
import { ReactComponent as LogoWithName } from "logic/src/components/icons/logoWithName.svg";
import SessionList from "@/pages/Chat_v2/components/SessionList";
import PopAI from "@/pages/Chat_v2/components/PopAI";
import PopStatus from "@/pages/Chat_v2/components/PopStatus";
import PopUser from "@/pages/Chat_v2/components/PopUser";
import QuestionInput from "@/components/QuestionInput_v2";
import ModelSelector from "@/components/ModelSelector";
import UserCenterFooter from "@/pages/Chat_v2/components/UserCenterFooter";
import { ReactComponent as BackIcon } from "logic/src/components/icons/back.svg";
import { EFileQueryType, ISelection } from "logic/src/objects/chat/types";
import authVM from "logic/src/businesses/auth/vm";
import { getQAFromDom, getGuessFromDom } from "@/pages/Chat_v2/utils/utils";
import styles from "@/pages/Chat_v2/index.module.scss";
import VideoUpload from "./components/VideoUpload";
import { MAX_VIDEO_SESSION_NUM } from "logic/src/constants";
import VideoClipper from "./components/VideoClipper";
import VideoPlayer from "./components/VideoPlayer";
import {
  EVideoInfoParseStatus,
  EVideoUploadStatus,
  IVideoClipInfo,
} from "logic/src/objects/video/types";
import { VIDEO_DISABLE_TIP } from "logic/src/constants/user";
import { IShortCommand, EShortCommand } from "./types";
import { sendCLK } from "logic/src/utils/eventTrack";

const Load_Threshold = 0;
const CHAT_REFRESH_KEY = "isChatRefresh";

const VideoUnderstanding = () => {
  const { t } = useTranslation();
  const {
    wrapperRef,
    bsRef,
    init,
    scrollViewToBottomImmediately,
    scrollViewToBottom,
    scrollDirectionRef,
  } = useScroll({
    autoScroll: true,
  });
  const navigate = useNavigate();
  const messageApi = useMessage();
  const inputRef = useRef<any>();
  const transInputRef = useRef<any>();
  const [isFoldBar, setIsFoldBar] = useState<boolean>(false);
  const [folderToolTipOpen, setFolderToolTipOpen] = useState<boolean>(false);
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [richmodalVM] = useState(() => new RichmodalVM(EChatModel.Video));
  const [isTransMode, setIsTransMode] = useState(false);
  const { id } = useParams();
  const [isQASession, setIsQASession] = useState(false);

  const shortCommandList = useMemo(() => {
    return [
      {
        command: EShortCommand.VIDEO_CAPTURE,
        icon: VideoCaptureIcon,
        name: "视频截取",
        prompt:
          "找到视频中所有关于“某项事物”的时间段，请用[mm:ss-mm:ss]来表示时间段，并在每个片段后加入一个详细的描述，某项事物为：",
      },
      {
        command: EShortCommand.AMAZING_CAPTURE,
        icon: AmazingCaptureIcon,
        name: "精彩剪辑",
        prompt:
          "请帮我剪辑视频中的片段，包含任意由客户指定的场景，提取相关片段，标明时间范围，并为每个片段配上解说文案，用户场景为：",
      },
      {
        command: EShortCommand.DETAIL_DESCRIPTION,
        icon: DetailDescriptionIcon,
        name: "详尽描述",
        prompt:
          "1. 请指出片段所在的时间范围 (以秒为单位, 例如: [mm:ss-mm:ss])。\n 2. 详细描述每一个视频片段。\n 3. 最后给出完整的视频描述。",
      },
      {
        command: EShortCommand.AUDIO_ANALYSIS,
        icon: AudioAnalysisIcon,
        name: "音频分析",
        prompt: "帮我总结下每个人都说了什么，按时间段总结",
      },
    ];
  }, []);
  const [currentShortCommand, setCurrentShortCommand] =
    useState<IShortCommand | null>(null);
  // 剪辑状态
  const [clipStatus, setClipStatus] = useState<EVideoInfoParseStatus>(
    EVideoInfoParseStatus.parsing,
  );
  const [clipSegmentObjs, setClipSegmentObjs] = useState<IVideoClipInfo[]>([]);

  // 开始剪辑的按钮，设置剪辑状态为已处理，并设置剪辑片段
  const handleClipStart = () => {
    setClipStatus(EVideoInfoParseStatus.end);
    // setClipSegmentObjs([
    //   {
    //     start: 1000, // 1s开始
    //     end: 5000, // 5s结束
    //     index: 1, // 原视频1
    //     title: "剪辑片段1",
    //     other: "其他信息1",
    //     description: "描述1",
    //     reason: "原因1",
    //   },
    //   {
    //     start: 1000, // 1s开始
    //     end: 10000, // 10s结束
    //     index: 2, // 原视频2
    //     title: "剪辑片段2",
    //     other: "其他信息2",
    //     description: "描述2",
    //     reason: "原因2",
    //   },
    //   {
    //     start: 5000, // 5s开始
    //     end: 10000, // 10s结束
    //     index: 1, // 原视频1
    //     title: "剪辑片段3",
    //     other: "其他信息3",
    //     description: "描述3",
    //     reason: "原因3",
    //   },
    // ]);
    setClipSegmentObjs([
      // {
      //   "index": 1,
      //   "start": 30000,
      //   "end": 36000,
      //   "title": "火箭绝杀勇士",
      //   "other": "原6秒→加速1.5倍后4秒",
      //   "description":
      //     "终场哨响前0.8秒，火箭球员底角接球完成压哨三分，比分从113-116逆转为119-116。慢镜头显示球沿筐沿旋转7圈后入网，现场LED屏瞬间变蓝。",
      //   "reason":
      //     "完美诠释&quot;最后一投定乾坤&quot;的篮球魅力，慢动作特写极具电影感，建议保留完整进球过程并叠加0.5倍速回放。",
      //   "commentary": "&quot;当时间归零，信仰出手！&quot;",
      // },
      // {
      //   "index": 1,
      //   "start": 5000,
      //   "end": 12000,
      //   "title": "凯尔特人暴力扣篮",
      //   "other": "原7秒→截取00:08-00:12共4秒",
      //   "description":
      //     "塔图姆持球突破完成单手劈扣，慢镜头展现其滞空高度超过篮筐，落地时地板反光形成光晕特效。",
      //   "reason":
      //     "力量美学的最佳体现，建议截取球入框瞬间至落地反光消失段落，突出肌肉线条与光影变化。",
      //   "commentary": "&quot;钢铁意志铸就空中利刃！&quot;",
      // },
      // {
      //   "index": 1,
      //   "start": 84000,
      //   "end": 92000,
      //   "title": "雄鹿字母哥暴扣",
      //   "other": "原8秒→加速1.2倍后6.5秒",
      //   "description":
      //     "字母哥接底线发球直接起飞，完成背身后拉杆滑翔劈扣，慢镜头显示其手臂完全伸展时肘部角度超过120度。",
      //   "reason":
      //     "展现超人类身体素质，建议保留起跳到入框全过程，并在最高点做0.5秒定格处理。",
      //   "commentary": "&quot;希腊神兽降临禁区！&quot;",
      // },
      {
        "index": 1,
        "start": 111000,
        "end": 120000,
        "title": "公牛逆风三分",
        "other": "原8秒→截取01:52-01:57共5秒",
        "description":
          "公牛落后8分时，韦德右侧45度迎着防守干拔三分，球在空中划出完美弧线，哨响同时球进灯亮。",
        "reason":
          "典型&quot;韦德式&quot;英雄球，建议保留运球后撤步到出手阶段，删除后续庆祝画面。",
        "commentary": "&quot;风城孤勇者，永不熄灭的火种！&quot;",
      },
      // {
      //   "index": 1,
      //   "start": 154000,
      //   // "start": 155000,
      //   // "end": 164000,
      //   // "end": 160000,
      //   "end": 155000,
      //   // "end": 158000,
      //   "title": "棒糖哥绝命三分",
      //   "other": "原8秒→加速1.3倍后6秒",
      //   "description":
      //     "比赛最后0.3秒，罗宾逊接界外球完成不可能的超远三分，慢镜头显示球在空中旋转11周后入网。",
      //   "reason":
      //     "最具娱乐性的神仙球，建议保留接球到出手全过程，叠加虚拟轨迹线增强观赏性。",
      //   "commentary": "&quot;当奇迹穿上篮球鞋！&quot;",
      // },
    ]);
  };

  useEffect(() => {
    const isChatRefresh = localStorage.getItem(CHAT_REFRESH_KEY) === "true";
    richmodalVM.init(isChatRefresh ? undefined : getQAFromDom()).then(() => {
      if (id) {
        const guessList = getGuessFromDom();
        if (guessList) {
          richmodalVM.guess.setGuessList(guessList);
        }
      }
    });

    localStorage.removeItem(CHAT_REFRESH_KEY);
  }, []);

  useEffect(() => {
    if (isTransMode && !richmodalVM.isLogin) {
      setIsTransMode(false);
    }
  }, [richmodalVM.isLogin]);

  useEffect(() => {
    if (isTransMode && richmodalVM.previewingFile) {
      handleToggleInput();
    }
  }, [richmodalVM.previewingFile]);

  useEffect(() => {
    handleInputFocus();
  }, [isTransMode]);

  useEffect(() => {
    !showLoginDialog && setIsQASession(false);
  }, [showLoginDialog]);

  const foldBar = () => {
    setFolderToolTipOpen(false);
    setIsFoldBar(true);
  };

  const unFoldBar = () => {
    setFolderToolTipOpen(false);
    setIsFoldBar(false);
  };

  const gotoLogin = useCallback(() => {
    setShowLoginDialog(true);
  }, []);

  const openLoginByAction = (isNewChat?: boolean) => {
    setIsQASession(!isNewChat);
    gotoLogin();
  };

  const { run: handleContentScroll } = useDebounceFn(
    () => {
      if (wrapperRef.current) {
        const { scrollTop } = wrapperRef.current;

        const canLoadMore =
          richmodalVM.canFetchHistory &&
          scrollDirectionRef.current === "down" &&
          // scrollHeight > clientHeight &&
          scrollTop <= Load_Threshold;

        if (canLoadMore) {
          const firstChild = bsRef.current?.firstElementChild;
          richmodalVM.session?.getChatInstanceList().then(hasMore => {
            if (hasMore) {
              firstChild?.scrollIntoView();
              wrapperRef.current!.scrollTop -= 100;
            }
          });
        }
      }
    },
    {
      wait: 100,
    },
  );

  const handleSessionChange = (id: string, tempId?: string) => {
    setIsTransMode(false);
    inputRef.current?.clear();
    richmodalVM.video.setFileList([]);
    richmodalVM.setFileSelectText(null);
    richmodalVM.selectSession(id, tempId);
    handleInputFocus();
    setTimeout(() => {
      scrollViewToBottomImmediately();
      init();
    }, 100);
  };

  const handleSendMessage = (
    text: string,
    fileList: UploadedFile[],
    fileQueryInfo?: ISelection,
    type?: EFileQueryType,
    guess?: boolean,
  ) => {
    sendCLK(
      "video_context_chat",
      "视频理解_文本聊天_" +
        (richmodalVM.chatModel === EChatModel.VideoR1
          ? "深度思考"
          : "普通聊天"),
    );
    richmodalVM.sendMsg(text, fileList, fileQueryInfo, type, guess);
    handleAfterSend();
  };

  const handleReAsk = (chat: Chat) => {
    richmodalVM.reAsk(chat);
  };

  const handleAfterSend = () => {
    handleInputFocus();
    setTimeout(() => {
      scrollViewToBottom();
    }, 300);
  };

  const handleNewSession = () => {
    if (richmodalVM.sessionManager?.sessionListLen >= MAX_VIDEO_SESSION_NUM) {
      return messageApi.info(VIDEO_DISABLE_TIP);
    }
    if (!richmodalVM.isLogin) {
      return openLoginByAction(true);
    }
    if (
      !richmodalVM.session?.id &&
      !richmodalVM.session.title &&
      !richmodalVM.session.chatInstanceList.length
    ) {
      handleInputFocus();
      return messageApi.info(t("sensechat-248"));
    }
    richmodalVM.setFileSelectText(null);
    richmodalVM.newSession();
    if (isTransMode) {
      handleToggleInput();
    }
    handleInputFocus();
  };

  const handleToggleInput = () => {
    if (!richmodalVM.isLogin) {
      return openLoginByAction(true);
    }
    if (isTransMode) {
      // 关闭翻译输入框
      const inputText = transInputRef.current?.getInputValue();
      inputRef.current?.setInputValue(inputText);
      transInputRef.current?.clear();
    } else {
      // 展示翻译输入框
      const inputText = inputRef.current?.getInputValue();
      transInputRef.current?.setInputValue(inputText);
      inputRef.current?.clear();
      richmodalVM.setFileSelectText(null);
    }
    setIsTransMode(!isTransMode);
  };

  const handleInputFocus = () => {
    if (richmodalVM.isLogin) {
      isTransMode
        ? transInputRef.current?.focusInput()
        : inputRef.current?.focusInput();
    }
  };

  const handleShortCommandClick = (item: IShortCommand) => {
    switch (item.command) {
      case EShortCommand.VIDEO_CAPTURE:
        sendCLK("video_trim_click", "视频理解_视频截取点击");
        break;
      case EShortCommand.AMAZING_CAPTURE:
        sendCLK("video_highlightclip_click", "视频理解_精彩剪辑点击");
        break;
      case EShortCommand.DETAIL_DESCRIPTION:
        sendCLK("video_detaildesc_click", "视频理解_详尽描述点击");
        break;
      case EShortCommand.AUDIO_ANALYSIS:
        sendCLK("video_audioanalysis_click", "视频理解_音频分析点击");
    }
    // 如果非当前选中的命令，则设置为当前选中的命令
    if (item.command !== currentShortCommand?.command) {
      setCurrentShortCommand(item);
      inputRef.current?.setInputValue(item.prompt);
    } else {
      // 如果相等，判断当前输入框是否修改，如果修改不清空
      if (inputRef.current?.getInputValue() === item.prompt) {
        inputRef.current?.clear();
      }
      setCurrentShortCommand(null);
    }
  };

  // const startLive = () => {
  //   liveInterval.current = setInterval(() => {
  //     live();
  //   }, 60 * 1000);
  // }

  // const stopLive = useCallback(() => {
  //   if(liveInterval.current) clearInterval(liveInterval.current as any)
  // }, [])
  const handleChatErrorRefresh = () => {
    if (getQAFromDom()) {
      localStorage.setItem(CHAT_REFRESH_KEY, "true");
    }
    location.reload();
  };

  const handleLogoutAndLogOff = () => {
    if (id) {
      window.location.reload();
    } else {
      richmodalVM.resetInit();
      navigate("/");
    }
  };
  const handleResetHome = () => {
    if (richmodalVM.chat) {
      richmodalVM.resetHome();
    }
  };

  useEffect(() => {
    if (richmodalVM.isLogin) {
      richmodalVM.user.checkVideoWhiteList().then(res => {
        if (res !== "authorized") {
          messageApi.error("您的暂时无法体验视频理解，请申请试用");
          navigate("/");
        }
      });
    } else {
      navigate("/");
    }
  }, []);

  const handleChat = () => {
    sendCLK("video_confirm_click", "视频理解_确认按钮点击");
    if (!isFoldBar) {
      setIsFoldBar(true);
    }
    richmodalVM.startVideoChat();
  };

  const deepthinkClassName = cls(
    styles.chatTypeSelector,
    richmodalVM.chatModel === EChatModel.VideoR1 && styles.selected,
    richmodalVM.web_search && styles.disabled,
  );

  // const searchClassName = cls(
  //   styles.chatTypeSelector,
  //   richmodalVM.web_search && styles.selected,
  //   richmodalVM.chatModel == EChatModel.R1 && styles.disabled,
  // );

  const handleToggleDeepThink = () => {
    if (!richmodalVM.web_search) {
      richmodalVM.setChatModel(
        richmodalVM.chatModel === EChatModel.VideoR1
          ? EChatModel.VideoEdit
          : EChatModel.VideoR1,
      );
    }
  };

  const handleToggleSearch = () => {
    if (richmodalVM.chatModel !== EChatModel.R1) {
      richmodalVM.setWebSearch(!richmodalVM.web_search);
    }
  };

  // const videoInfoList = useMemo(() => {
  //   if (richmodalVM.video.fileList) {
  //     return richmodalVM.video.fileList;
  //   }
  //   return undefined;
  // }, [richmodalVM.video.fileList]);
  let remainTime =
    MAX_VIDEO_SESSION_NUM - (richmodalVM.sessionManager?.sessionListLen || 0);
  remainTime = remainTime < 0 ? 0 : remainTime;

  return (
    <>
      <div className={styles.container}>
        {/* <Header onClickLogo={handleResetHome} /> */}
        {/* <AppQRCode
          className={cls(
            styles.headerQrcode,
            richmodalVM.isLogin && styles.headerQrcodeLogin,
          )}
        /> */}
        <div className={styles.chatContent}>
          {isFoldBar ? (
            <div className={styles.chatContentLeftFold}>
              <Logo className={styles.logo} />
              <div className={styles.foldIcon}>
                <Tooltip
                  open={folderToolTipOpen}
                  placement="top"
                  trigger="hover"
                  color="#242424"
                  title="展开侧栏"
                >
                  <UnFold
                    onClick={unFoldBar}
                    onMouseEnter={() => setFolderToolTipOpen(true)}
                    onMouseLeave={() => setFolderToolTipOpen(false)}
                  />
                </Tooltip>
              </div>
              <Plus className={styles.plus} onClick={handleNewSession} />
              {richmodalVM.isLogin && (
                <div className={styles.user}>
                  <UserCenterFooter
                    resetInit={handleLogoutAndLogOff}
                    fold={isFoldBar}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={styles.chatContentLeft}>
              <div className={styles.logoContainer}>
                <LogoWithName
                  className={styles.logo}
                  style={{
                    cursor: richmodalVM.isLogin ? "initial" : "pointer",
                  }}
                  onClick={handleResetHome}
                />
                <Tooltip
                  open={folderToolTipOpen}
                  placement="top"
                  trigger="hover"
                  color="#242424"
                  title="收起侧栏"
                >
                  <Fold
                    className={styles.foldIcon}
                    onClick={foldBar}
                    onMouseEnter={() => setFolderToolTipOpen(true)}
                    onMouseLeave={() => setFolderToolTipOpen(false)}
                  />
                </Tooltip>
              </div>

              {richmodalVM.sessionManager && (
                <SessionList
                  isVideoType={true}
                  isLogin={richmodalVM.isLogin}
                  query={richmodalVM.sessionManager?.query}
                  isFetchData={
                    richmodalVM.sessionManager?.query
                      ? richmodalVM.sessionManager?.isQuerying
                      : richmodalVM.sessionManager?.isFetchList
                  }
                  sessionList={
                    richmodalVM.sessionManager?.query
                      ? richmodalVM.sessionManager?.queryListGroup
                      : richmodalVM.sessionManager?.list || []
                  }
                  session={richmodalVM.session}
                  onUnPinned={richmodalVM.sessionManager.unPinned}
                  onPinned={richmodalVM.sessionManager.pinned}
                  onChange={handleSessionChange}
                  onDelete={richmodalVM.deleteSession}
                  onEditName={richmodalVM.editSessionName}
                  onNewSession={handleNewSession}
                  onQuerySession={richmodalVM.sessionManager.querySession}
                  onLoadSession={richmodalVM.sessionManager?.fetchMoreSession}
                />
              )}
              {authVM.isLogin && <FeedBackBar />}
              {authVM.isLogin && (
                <UserCenterFooter
                  fold={isFoldBar}
                  resetInit={handleLogoutAndLogOff}
                />
              )}
            </div>
          )}
          <div
            className={styles.chatContentWrap}
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              overflow: "hidden",
            }}
          >
            <div className={styles.ModelSelectorWrap}>
              <ModelSelector />
              {/* <div className={styles.useTime}>
                功能内测中，可使用{" "}
                <span className={styles.time}>{MAX_VIDEO_SESSION_NUM}</span> 次
                (剩余 <span>{remainTime}</span> 次)
              </div> */}
            </div>
            {richmodalVM.session.chatInstanceList.length > 0 && (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flex: 1,
                  height: "calc(100vh - 60px)",
                }}
              >
                <div
                  className={styles.chatContentRightFile}
                  style={{
                    position: "relative",
                    width: "50%",
                    overflow: "auto",
                    height: "calc(100vh - 120px)",
                    padding: "10px",
                  }}
                >
                  {/* 视频播放预览 - 使用新VideoPlayer组件展示多视频 */}
                  {richmodalVM.video.fileList.length > 0 ? (
                    <>
                      {/* <div
                        style={{
                          marginBottom: "10px",
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        <button
                          style={{
                            padding: "5px 10px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            richmodalVM.video.setCurrentVideoIndex(1);
                            richmodalVM.video.setCurrentVideoSeekTime("00:02");
                          }}
                        >
                          定位到视频1的2秒处
                        </button>
                        <button
                          style={{
                            padding: "5px 10px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            richmodalVM.video.setCurrentVideoIndex(1);
                            richmodalVM.video.setCurrentVideoSeekTime("00:10");
                          }}
                        >
                          定位到视频1的10秒处
                        </button>
                        <button
                          style={{
                            padding: "5px 10px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            richmodalVM.video.setCurrentVideoIndex(2);
                            richmodalVM.video.setCurrentVideoSeekTime("00:04");
                          }}
                        >
                          定位到视频2的4秒处
                        </button>
                        <button
                          style={{
                            padding: "5px 10px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            richmodalVM.video.setCurrentVideoIndex(3);
                            richmodalVM.video.setCurrentVideoSeekTime("00:06");
                          }}
                        >
                          定位到视频3的6秒处
                        </button>
                      </div> */}
                      <VideoPlayer
                        videos={richmodalVM.video.fileList}
                        className={styles.videoPlayer}
                        autoPlay={false}
                        autoGenerateThumbnails={false}
                        currentVideoInfo={richmodalVM.video.currentVideo}
                        resetSeekTime={() => {
                          console.log("[父组件] 收到重置时间戳请求");
                          // 直接更新时间戳，不使用setTimeout
                          richmodalVM.video.currentVideo = {
                            ...richmodalVM.video.currentVideo,
                            seekTime: "00:00",
                          };
                        }}
                        onVideoChange={index => {
                          // 视频变更为基于0的索引，需要+1转为基于1的索引
                          const newIndex = index + 1;
                          console.log(`[父组件] 收到视频切换请求: ${newIndex}`);

                          // 当前model中的视频索引
                          const currentIndex =
                            richmodalVM.video.currentVideo.index;
                          console.log(`[父组件] 当前视频索引: ${currentIndex}`);

                          // 只有索引变化时才更新
                          if (newIndex !== currentIndex) {
                            console.log(
                              `[父组件] 更新视频索引: ${currentIndex} -> ${newIndex}`,
                            );
                            richmodalVM.video.setCurrentVideoIndex(newIndex);
                          }
                        }}
                      />

                      {/* 视频剪辑按钮 */}
                      {/* <div
                        style={{
                          marginTop: "12px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            padding: "8px 16px",
                            borderRadius: "4px",
                            background: "#1677ff",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                          onClick={handleClipStart}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9 4H7C5.89543 4 5 4.89543 5 6V18C5 19.1046 5.89543 20 7 20H9C10.1046 20 11 19.1046 11 18V6C11 4.89543 10.1046 4 9 4Z"
                              fill="currentColor"
                            />
                            <path
                              d="M17 4H15C13.8954 4 13 4.89543 13 6V18C13 19.1046 13.8954 20 15 20H17C18.1046 20 19 19.1046 19 18V6C19 4.89543 18.1046 4 17 4Z"
                              fill="currentColor"
                            />
                          </svg>
                          开始视频剪辑
                        </button>
                      </div> */}

                      {/* 使用VideoClipper组件展示剪辑片段 */}
                      {clipStatus === EVideoInfoParseStatus.end && (
                        <div style={{ marginTop: "12px" }}>
                          <VideoClipper
                            sessionId={richmodalVM.session?.id || ""}
                            status={clipStatus}
                            videosInfo={richmodalVM.video.fileList.map(
                              file => ({
                                url: file.url,
                                fileId: file.fileId,
                              }),
                            )}
                            clipSegmentObs={clipSegmentObjs}
                          />
                        </div>
                      )}
                    </>
                  ) : null}
                </div>
                <div
                  className={cls(styles.chatContentRight, {
                    [styles.chatContentFolded]:
                      richmodalVM.session.chatInstanceList.length > 0,
                  })}
                  style={{
                    position: "relative",
                    width: "50%",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    paddingTop: "66px",
                  }}
                >
                  <div
                    className={styles.loadingWrap}
                    style={{
                      display: richmodalVM.session.isFetchingList
                        ? "block"
                        : "none",
                    }}
                  >
                    <LoadingOutlined
                      style={{ fontSize: 20, color: "#C5C5C5" }}
                    />
                  </div>
                  <div
                    ref={wrapperRef}
                    onScroll={handleContentScroll}
                    className={cls(styles.chatWrap)}
                    style={{
                      flex: 1,
                      overflow: "auto",
                      height: "calc(100vh - 220px)",
                    }}
                  >
                    <div ref={bsRef} className={styles.chatText}>
                      {richmodalVM.chat && (
                        <Fragment key="unlogin-chat">
                          <PopUser
                            files={richmodalVM.chat.files}
                            sessionFileIds={
                              richmodalVM.session.fileManager?.fileIds || []
                            }
                            isLogin={richmodalVM.isLogin}
                            messageList={richmodalVM.chat.send_msg!}
                            textMessageList={richmodalVM.chat.inputMessageList}
                            sessionLinkFileIdMap={
                              richmodalVM.session.fileManager?.linkFileIdMap ||
                              {}
                            }
                            onPreviewFile={richmodalVM.selectPreviewFile}
                          />
                          <PopAI
                            onReAsk={handleReAsk}
                            chatInfo={richmodalVM.chat}
                            isLast={true}
                          />
                        </Fragment>
                      )}
                      {richmodalVM.video.uploadStatus ===
                        EVideoUploadStatus.UPLOADING && (
                        <PopStatus text={"正在上传视频"} />
                      )}
                      {richmodalVM.session.chatInstanceList.map(
                        (item: Chat, index: number) => (
                          <Fragment key={item.message_id}>
                            {index === 0 ? null : (
                              <PopUser
                                isTransMsg={item.isTransMsg}
                                onFileSelectionClick={
                                  richmodalVM.highLightSelectText
                                }
                                files={item.files}
                                sessionFileIds={
                                  richmodalVM.session.fileManager?.fileIds || []
                                }
                                sessionLinkFileIdMap={
                                  richmodalVM.session.fileManager
                                    ?.linkFileIdMap || {}
                                }
                                isLogin={richmodalVM.isLogin}
                                messageList={item.send_msg!}
                                textMessageList={item.inputMessageList}
                                onPreviewFile={richmodalVM.selectPreviewFile}
                              />
                            )}

                            <PopAI
                              videoInfoList={richmodalVM.video.fileList}
                              onReAsk={handleReAsk}
                              chatInfo={item}
                              onVideoTimeClick={
                                richmodalVM.handleVideoTimeClick
                              }
                              isLast={
                                index ===
                                richmodalVM.session!.chatInstanceList.length - 1
                              }
                              onInputFocus={handleInputFocus}
                              onChatErrorRefresh={handleChatErrorRefresh}
                              // onStreamEnd={richmodalVM.handleStreamEnd}
                            />
                          </Fragment>
                        ),
                      )}
                    </div>
                  </div>
                  {richmodalVM.session.chatInstanceList.length > 0 && (
                    <div
                      className={styles.chatFooter}
                      style={{ height: "auto", paddingBottom: "32px" }}
                    >
                      <div className={styles.shortCommandWrap}>
                        <div className={styles.typeSelectBox}>
                          {/* {!richmodalVM.previewingFile && (
                            <Popover content={popoverContent} color="#000">
                              <div
                                className={deepthinkClassName}
                                onClick={handleToggleDeepThink}
                                data-ti="translate_click"
                                data-tn="翻译入口点击"
                                style={{
                                  marginRight: "10px",
                                }}
                              >
                                <DeepThink className={styles.typeIcon} />
                                <span className={styles.text}>深度思考</span>
                              </div>
                            </Popover>
                          )} */}
                          {/* {!richmodalVM.previewingFile && (
                            <div
                              className={deepthinkClassName}
                              onClick={handleToggleDeepThink}
                              data-ti="translate_click"
                              data-tn="翻译入口点击"
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              <DeepThink className={styles.typeIcon} />
                              <span className={styles.text}>深度思考</span>
                            </div>
                          )} */}
                          {shortCommandList.map(
                            (item: IShortCommand, index) => {
                              return (
                                <div
                                  key={index}
                                  className={cls(styles.shortCommand, {
                                    [styles.selected]:
                                      item.command ===
                                      currentShortCommand?.command,
                                  })}
                                  onClick={() => handleShortCommandClick(item)}
                                >
                                  <item.icon className={styles.svg} />
                                  <span className={styles.text}>
                                    {item.name}
                                  </span>
                                </div>
                              );
                            },
                          )}
                        </div>
                      </div>

                      <QuestionInput
                        visible={!isTransMode}
                        ref={inputRef}
                        isLogin={richmodalVM.isLogin}
                        gotoLogin={openLoginByAction}
                        isFetching={richmodalVM.isPending}
                        handleSendMessage={handleSendMessage}
                        maxLength={10000}
                        totalToken={richmodalVM.session.total_token}
                        fileSelection={richmodalVM.fileSelectText || undefined}
                        onDeleteFileSelection={richmodalVM.removeFileText}
                        observeBody
                        setCurrentShortCommand={setCurrentShortCommand}
                      />
                      {/* <p className={styles.chatFooterPrivacy}>
                      注意：以上回复全部由AI技术合成，请遵守
                      <span
                        onClick={() => handleShowAgreement(AgreeType.userPrivacy)}
                      >
                        《用户协议》
                      </span>
                      和
                      <span
                        onClick={() => handleShowAgreement(AgreeType.infoCollect)}
                      >
                        《隐私政策》
                      </span>
                      。
                    </p> */}
                    </div>
                  )}
                </div>
              </div>
            )}
            {richmodalVM.session.chatInstanceList.length === 0 &&
              (!richmodalVM.sessionChanging ? (
                <div
                  className={cls(styles.chatContentRight)}
                  style={{
                    position: "relative",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    className={styles.loadingWrap}
                    style={{
                      display: richmodalVM.session.isFetchingList
                        ? "block"
                        : "none",
                    }}
                  >
                    <LoadingOutlined
                      style={{ fontSize: 20, color: "#C5C5C5" }}
                    />
                  </div>
                  <div
                    ref={wrapperRef}
                    onScroll={handleContentScroll}
                    className={cls(styles.chatWrap)}
                    style={{
                      flex: 1,
                      overflow: "auto",
                      height: "calc(100vh - 160px)",
                    }}
                  >
                    <div ref={bsRef} className={styles.chatText}>
                      <VideoUpload
                        uploadUrl={richmodalVM.uploadVideoUrl}
                        uploadVideo={richmodalVM.uploadVideo}
                        fileList={richmodalVM.video.fileList}
                        onConfirm={handleChat}
                        onDelete={richmodalVM.video.deleteFile}
                        fileUploading={
                          !richmodalVM.video.allDone ||
                          richmodalVM.video.fileList.length === 0
                        }
                        disabled={
                          richmodalVM.sessionManager?.sessionListLen >=
                          MAX_VIDEO_SESSION_NUM
                        }
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles.changeLoadingWrap}>
                  <LoadingOutlined
                    style={{
                      fontSize: 20,
                      color: "#C5C5C5",
                    }}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
      {!!authVM.user.watermark && (
        <WaterMark
          gapX={170}
          gapY={150}
          content={[authVM.user.watermark, t("sensechat-42")]} // 内容由AI生成仅供参考
          fontColor="rgba(108, 112, 117, 0.06)"
          fontSize={12}
        />
      )}
      {messageApi.contextHolder}
    </>
  );
};
export default observer(VideoUnderstanding);
